<template>
  <div class="library-page">
    <div class="header">Apphi Library</div>
    <div class="tab-container">
      <div class="space-container"></div>
      <!-- <hi-tab height="48px" v-model="tabIndex" :tabList="tabList" class="tab-list"></hi-tab> -->
      <div class="space-container">
        <template v-if="tabIndex === 0">
          <hi-button
            type="text"
            class="del-btn"
            v-show="!mediaDelete"
            @click="mediaDelete = true"
            >Delete</hi-button
          >
          <hi-button
            type="text"
            class="del-btn"
            v-show="mediaDelete"
            @click="mediaDelete = false"
            >Cancel</hi-button
          >
          <hi-button
            type="text"
            class="del-btn"
            v-show="mediaDelete"
            @click="delMedia"
            >Delete</hi-button
          >
          <upload-btn ref="uploadBtn" target="#mediaList" v-show="!mediaDelete">
            <hi-button class="del-btn" type="text">Upload</hi-button>
          </upload-btn>
        </template>
      </div>
    </div>
    <div
      v-show="tabIndex === 0"
      ref="media"
      id="mediaList"
      class="media-list"
      :class="{ empty: mediaEmpty }"
    >
      <div
        v-show="mediaEmpty"
        class="empty-text"
        @click="$refs.uploadBtn.uploadMediaClick()"
      >
        Upload Media from Computer
      </div>
      <image-shade
        @click.native="select(image)"
        class="media-item"
        :item="image"
        :src="image.coverUrl"
        :key="image.id"
        v-for="image in mediaList.list"
      >
        <div v-lazy:background-image="image.coverUrl" class="media-item">
          <div
            v-show="mediaDelete"
            class="del-icon"
            :class="{ selected: image.del }"
          ></div>
        </div>
      </image-shade>
      <div class="load-more-container" v-show="!mediaEmpty">
        <el-button
          v-show="!mediaListLoading && !mediaLibraryList.end"
          size="mini"
          style="width: 100%"
          @click="loadMoreMedia()"
        >
          Load more
        </el-button>
        <div
          v-show="mediaLibraryList.end && !mediaListLoading"
          style="color: rgb(140, 140, 140)"
        >
          end
        </div>
        <div v-show="mediaListLoading">
          <i class="el-icon-loading"></i> Loading
        </div>
      </div>
    </div>
    <div v-show="tabIndex === 1" class="media-list">
      <div
        v-lazy:background-image="image.coverUrl"
        :key="image.id"
        v-for="image in savedLibraryList.list"
        class="media-item"
        @click="select(image, 'saved')"
      >
        <div
          v-show="mediaDelete"
          class="del-icon"
          :class="{ selected: image.del }"
        ></div>
      </div>
      <div class="load-more-container">
        <el-button
          v-show="!savedListLoading && !savedLibraryList.end"
          size="mini"
          style="width: 100%"
          @click="loadSavedMoreMedia()"
        >
          Load more
        </el-button>
        <div v-show="savedListLoading">
          <i class="el-icon-loading"></i> Loading
        </div>
        <div
          v-show="savedLibraryList.end && !savedListLoading"
          style="color: rgb(140, 140, 140)"
        >
          end
        </div>
      </div>
    </div>
    <calender-preview-dialog ref="previewDialog"></calender-preview-dialog>
    <calender-schedule-form
      :formType="formType"
      ref="postFormDialog"
      v-if="showFormDialog"
    ></calender-schedule-form>
  </div>
</template>

<script>
import { loadMore, loadSavedMore, delGallery } from "../../service/media";
import { mapGetters } from "vuex";
import {
  MEDIA_LIBRARY_LIST,
  SAVED_LIBRARY_LIST,
} from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/errors";
import hiButton from "../../components/common/button/Index";
import uploadBtn from "../../components/library_menu/UploadBtn";
import calenderPreviewDialog from "../../components/media/preview_dialog/Index.vue";
import calenderScheduleForm from "../../components/media/schedule/form/Form";
import ImageShade from "../../components/common/media/ImageShade";
export default {
  name: "LibraryPage",
  components: {
    hiButton,
    uploadBtn,
    calenderPreviewDialog,
    calenderScheduleForm,
    ImageShade,
  },
  computed: {
    ...mapGetters({
      savedLibraryList: SAVED_LIBRARY_LIST,
      mediaLibraryList: MEDIA_LIBRARY_LIST,
    }),
    mediaList() {
      const media = this.mediaLibraryList;
      // 标注对应删除项
      media.list.forEach((item) => {
        if (this.mediaDeleteArray.find((mediaId) => mediaId === item.id)) {
          item.del = true;
        } else {
          item.del = false;
        }
      });
      return media;
    },
    mediaEmpty() {
      return this.mediaList.list.length === 0 && !this.mediaListLoading;
    },
  },
  data() {
    return {
      showFormDialog: false,
      formType: "",
      tabList: [
        {
          title: "Media",
        },
        {
          title: "Saved",
        },
      ],
      tabIndex: 0, // tab当先选中项
      mediaDelete: false, // 是否正处于删除状态
      mediaDeleteArray: [], // 待删除项
      mediaListLoading: false, // media是否在加载中
      savedListLoading: false, // saved是否在加载中
    };
  },
  async created() {
    try {
      await this.loadMoreMedia(true);
      // await this.loadSavedMoreMedia(true)
      // 监听通知是否刷新media
      this.$bus.$on("mediaLibraryReload", () => {
        this.loadMoreMedia(true);
      });
    } catch (e) {
      showErrorMsg(e);
    }
  },
  watch: {
    mediaDelete() {
      // 清空删除项目
      this.mediaDeleteArray = [];
    },
  },
  methods: {
    /**
     * 点击事件
     * @param m 选中项
     */
    select(m, type = "media") {
      // 判断如果是删除模式则开始计数
      if (this.mediaDelete) {
        // 判断是否已经添加过了，如果添加过则进行删除
        const delIndex = this.mediaDeleteArray.findIndex(
          (mediaId) => mediaId === m.id
        );
        if (delIndex > -1) {
          this.mediaDeleteArray.splice(delIndex);
        } else {
          // 将删除的media id添加到结果中
          this.mediaDeleteArray.push(m.id);
        }
      } else {
        if (type === "media") {
          // 判断当前点击的是save还是media
          this.$refs.previewDialog.open({ medias: [m] });
        } else {
          this.$bus.$emit("showRepostDetail", m);
        }
      }
    },
    /**
     * 加载media更多
     * @returns {Promise.<void>}
     */
    async loadMoreMedia(first) {
      try {
        this.mediaListLoading = true;
        await loadMore({ first });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.mediaListLoading = false;
      }
    },
    /**
     * 加载saved更多
     * @returns {Promise.<void>}
     */
    async loadSavedMoreMedia(first) {
      try {
        this.savedListLoading = true;
        await loadSavedMore({ first });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.savedListLoading = false;
      }
    },
    /**
     * 删除media中的选项
     * @returns {Promise<void>}
     */
    async delMedia() {
      // 显示Loading
      const loading = this.$loading({
        target: "#library-list",
      });
      try {
        await delGallery({ ids: this.mediaDeleteArray });
        this.mediaDelete = false;
      } catch (e) {
        console.error(e);
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.library-page {
  flex: 1;
  display: flex;
  flex-direction: column;

  .header {
    height: 80px;
    font-size: 18px;
    font-weight: 500;
    padding-left: 25px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid @border-color;
  }

  .tab-container {
    height: 50px;
    border-bottom: 1px solid @border-color;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 25px;

    .space-container {
      flex: 1;
      display: flex;
      justify-content: flex-end;

      .del-btn {
        font-size: 16px;
        margin-left: 44px;
        padding: 0;
      }
    }

    .tab-list {
      height: 60px;
      width: 160px;
    }
  }

  .load-more-container {
    width: 100%;
    padding: 20px;
    text-align: center;
    font-size: 16px;
  }

  .media-list {
    padding: 15px;
    height: calc(~"100vh - 140px");
    overflow: auto;
    font-size: 0;

    &.empty {
      align-items: center;
      justify-content: center;
      display: flex;

      .empty-text {
        color: rgba(140, 140, 140);
        cursor: pointer;
        text-decoration: underline;
        font-size: 14px;
      }
    }

    .media-item {
      width: 190px;
      height: 190px;
      margin: 1px;
      padding: 0;
      display: inline-block;
      background-size: cover;
      background-position: center;
      position: relative;
      cursor: pointer;
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;
      /* Non-prefixed version, currently
                                        supported by Chrome and Opera */

      .del-icon {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 44px;
        z-index: 9;
        height: 44px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../../public/images/common/Normal@3x.png");

        &.selected {
          background-image: url("../../../public/images/common/Select@3x.png");
        }
      }
    }
  }
}
</style>
